export default {"src":"/_next/static/media/arrowRight_24.3b9ac56e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};